/* eslint-disable react/no-array-index-key */
import React from 'react';

const StatusInsureds = (props) => (
    <React.Fragment>
        <div className="title-box">
            Segurados
        </div>
        <div className="box-insureds">
            { props.insureds.map(
                (insured, i) => (
                    <div className="infos-insureds" key={i}>
                        <strong>{insured.full_name}</strong><br />
                        <strong>{insured.document_type === 2 ? 'Passaporte:' : 'CPF:'}</strong>&nbsp;
                        <span>{insured.document}</span>
                    </div>
                ))
            }
        </div>
    </React.Fragment>
)

export default StatusInsureds;



// WEBPACK FOOTER //
// ./src/components/purchase_status/StatusInsureds.jsx